import { HexColorPicker } from 'react-colorful';
import type { FieldPath, FieldValues } from 'react-hook-form';
import { useController, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

export interface RhfColorPickerProps<T extends FieldValues> {
  name: FieldPath<T>;
  label: string;
  required?: boolean;
}

function RhfColorPicker<T extends FieldValues>({
  name,
  label,
  required,
}: RhfColorPickerProps<T>) {
  const { control } = useFormContext<T>();
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
    rules: required ? { required: `${label} is required` } : undefined,
  });

  return (
    <Box sx={{ '& .react-colorful': { width: '100%' } }}>
      <HexColorPicker
        color={field.value}
        onChange={(hex) => field.onChange(hex)}
      />

      {error ? (
        <Typography
          variant="caption"
          color="error"
          sx={{ display: 'block', mt: 0.5, mx: 1.75 }}
        >
          {error?.message}
        </Typography>
      ) : null}
    </Box>
  );
}

export default RhfColorPicker;
